import { LitElement, html, css, render } from 'lit';
import { search } from '../../utilities/icons';
import { EventManager } from '../../utilities/events';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInOrganisationSearch extends LitElement {
    static properties = {
        name: { type: String },
        loading: { type: Boolean, state: true },
        restUrl: { type: String },
        logoUrl: { type: String },
        nonce: { type: String },
        organisations: { type: Array, state: true },
        org_id: { type: String },
        members: { type: Boolean },
        has_searched: { type: Boolean, state: true },
        exclusions: { type: Array },
    };
    constructor() {
        super();
        this.organisations = [];
        this.loading = false;
        this.has_searched = false;
    }
    async connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
    }
    createRenderRoot() {
        return this;
    }
    get input() {
        return this.renderRoot.querySelector('input[name="organisation_id"]');
    }
    render() {
        let main = html `\n            <div class="allin-organisation-search-form ${this.loading ? "loading" : ""}" ?aria-busy=${this.loading} >\n                <div class="searchboxes">\n                    <div class="searchbox">\n                        <label for="allin-organisation-search">Search for an organisation</label>\n                        ${search}\n                        <input type="text" id="allin-organisation-search" name="search" value="${this.search}" @keydown=${this._handleKeydown}/>\n                    </div>\n                    <button class="button" ?disabled=${this.loading} @click=${this._handleSubmit}>Search</button>\n                </div>\n            </div>\n        `;
        let organisationsList = html ``;
        if (this.organisations && this.organisations.length > 0) {
            organisationsList = html `\n                <ul class="organisations-list">\n                ${this.organisations.map((org) => {
                if (this.members) {
                    let button = html `<button type="submit" @click=${() => this._selectOrganisation(org.organisation)}>Share your profile <span class="screen-reader-text">to ${org.name}</span></button>`;
                    let mesg = html `<p>'${org.name}' belongs to an organisation called '${org.organisation.name}'. You will be sharing your profile with this organisation and any of its locations.</p>`;
                    if (this.exclusions && this.exclusions.includes(org.organisation.id)) {
                        button = '';
                        mesg = html `<p>You are already sharing your profile with this organisation.</p>`;
                    }
                    return html `\n                                <li class="organisation">\n                                    ${org.photo1 ? html `<img src="${org.photo1.publicUrl}" alt="${org.name} image" />` : html `<div class="placeholder-image" aria-label="No image available"></div>`}\n                                    <h4>${org.name}</h4>\n                                    ${button}\n                                    ${mesg}\n                                </li>\n                            `;
                }
                else {
                    return html `\n                                <li class="organisation">\n                                    ${org.logoUrl ? html `<img src="${org.logoUrl}" alt="${org.name} image" />` : html `<div class="placeholder-image" aria-label="No image available"></div>`}\n                                    <h4>${org.name}</h4>\n                                    <button type="submit" @click=${() => this._selectOrganisation(org)}>Send invitation <span class="screen-reader-text">to ${org.name}</span></button>\n                                </li>\n                            `;
                }
            })}\n                </ul>\n                <div class="button_group button-group">\n                    <button class="button" @click=${(e) => { e.preventDefault(); this.organisations = []; }}>Clear search results</button>\n                </div>\n             `;
        }
        else if (this.has_searched) {
            organisationsList = html `\n                <p class="no-results">No organisations found. Please try a different search term.</p>\n            `;
        }
        return html `\n            <input type="hidden" name="organisation_id">\n            <div class="bg">\n                ${main}\n                ${organisationsList}\n            </div>\n        `;
    }
    async _handleSubmit(e) {
        e.preventDefault();
        this.loading = true;
        const searchInput = this.renderRoot.querySelector('#allin-organisation-search');
        const search = searchInput?.value?.trim();
        if (!search || search.length < 3) {
            console.warn('Search term must be at least 3 characters');
            this.loading = false;
            return;
        }
        const params = new URLSearchParams();
        //const search = this.renderRoot.querySelector('#allin-organisation-search').value;
        params.append('name', search);
        if (this.org_id) {
            params.append('org_id', this.org_id);
        }
        if (this.members) {
            params.append('members', true);
        }
        // if(search) params.append('search', search);
        // if(this._pageNumber) params.append('pageNumber', this._pageNumber);
        try {
            const response = await fetch(`${this.restUrl}?action=get_search_orgs&${params.toString()}`, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            const data = await response.json();
            if (data) {
                this.organisations = data;
            }
        }
        catch (error) {
            console.error('Error fetching locations:', error);
        }
        finally {
            this.loading = false;
            this.has_searched = true;
        }
        this.loading = false;
        // this.organisations = this.dummyorganisations;
    }
    _selectOrganisation(organisation) {
        console.log('Selected organisation:', organisation);
        this.input.value = organisation.id;
    }
    _handleKeydown(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this._handleSubmit(e);
        }
    }
}
